import React from 'react';
import { ScreenWrapper } from '../../components/Wrappers/ScreenWrapper';
import theme, { TMaterialStyles } from '../../theme';
import { Box } from '@mui/material';
import { Illustration } from '../../components/Illustration';
import { useTranslation } from 'react-i18next';
import TypogrphyWithShadow from '../../components/Typography/TypographyWithShadow';

const SplashScreen: React.FC = () => {
  const { t } = useTranslation();
  return (
    <ScreenWrapper>
      <Box sx={materialStyles.container}>
        <Illustration
          sx={materialStyles.loadingIllustration}
          illustrationName="HippoLoading"
        />
        <Box sx={materialStyles.titleWithSubtitleContainer}>
          <TypogrphyWithShadow sx={materialStyles.loadingTitle}>
            {t('common.loading')}
          </TypogrphyWithShadow>
          <TypogrphyWithShadow
            shadowType="DARK"
            sx={materialStyles.loadingSubtitle}
          >
            {t('common.searching_for_geolocation')}
          </TypogrphyWithShadow>
        </Box>
      </Box>
    </ScreenWrapper>
  );
};

const materialStyles: TMaterialStyles = {
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    textShadow: `0px 1px 0px ${theme.palette.secondary.main}`,
  },
  loadingIllustration: {
    width: '181px',
    height: '237px',
  },
  titleWithSubtitleContainer: {
    marginTop: '16px',
  },
  loadingTitle: {
    fontFamily: 'Rubber Duck !important',
    fontSize: '36px',
    lineHeight: '34px',
    textAlign: 'center',
  },
  loadingSubtitle: {
    color: theme.palette.text.primary,
    marginTop: '7px',
    fontSize: '15px',
    lineHeight: '18px',
    fontWeight: '600',
    textAlign: 'center',
  },
};

export default SplashScreen;
